<template>
	<div
		class="w-64 space-x-4 rounded flex flex-row"
		@click="
			!disabled && $emit('click', value);
			$store.commit('setConfirmLeaving', $t('leave_page'));
		"
		:class="{ 'pointer-events-none opacity-70': disabled, 'border-connectProBlue cursor-pointer': !disabled }"
	>
		<div class="flex items-center">
			<div class="rounded-full border-2 border-gray-700 h-4 w-4 flex items-center justify-center" :class="{ 'bg-connectProBlue': isActive }">
				<div v-if="isActive" class="white-circle"></div>
			</div>
		</div>
		<div class="w-1/4">
			<slot :name="`input_${label}`" v-if="isActive">
				<div v-html="label"></div>
			</slot>
			<div v-html="label" v-else></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CleanBaseRadio',
	props: {
		label: { required: true, type: String },
		disabled: {},
		value: { required: true },
		formValue: { required: true },
	},
	computed: {
		isActive() {
			return this.value === this.formValue;
		},
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
};
</script>

<style scoped>
.white-circle {
	@apply rounded-full bg-white;
	height: 6px;
	width: 6px;
}
</style>
